import config from '../config';

import { ApiCrud } from './api-crud';
import axiosWithCache from './api-cache';

const AXIOS = axiosWithCache('masterData', config.MasterDataCacheMin);

const masterDataApi = new ApiCrud(
  AXIOS,
  null, // no model
  {
    productCategories: '/productCategories',
    productCategory: '/productCategories/:id',

    productType: '/productTypes/:id',

    // deviceTypes: '/deviceTypes/:id',
    // deviceTypeMasters: '/deviceTypes/master',
    deviceTypesByCategoryId: '/deviceTypes',
    vendor3POptions: '/vendors',
    targetingTypes: '/productTypes/:id/targetingTypes/:targetingType',
    targetingTypesByLevel: '/productTypes/:id/targetingTypes/:targetingType/level/:level',
    targetingTypeOptions: '/targetableElement/:id/options',

    trackingTypes: '/trackingTypes',
    roles: '/roles',

    budgetRanges: '/options/budgetRanges',
    industries: '/options/industries',
    locations: '/options/locations',
    marketingObjectives: '/options/marketingObjectives',

    users: '/users',

    assignees: '/accounts/:id/dropdowns/ASSIGNEE',
    orderContacts: '/accounts/:id/dropdowns/CONTACT_USER',
    accountExecutives: '/accounts/:id/dropdowns/CUSTOM_USER',
    owners: '/accounts/:id/dropdowns/OWNER',

    kpiOptions: 'GET /productTypes/:id/kpiOptions',

    goalOptions: 'GET /productTypes/:id/goalOptions',

    flagOptions: 'GET /flagOptions',

    statusOptions: '/statusOptions/:type',

    priceTypesOptions: 'GET /priceTypeOptions',

    billingTypesOptions: 'GET /billingTypeOptions',

    hierarchies: '/hierarchies',

    targetingElements: '/targetingElements',

    allKpiOptions: '/kpiOptions',

    workflowOptions: '/workflowOptions',

    taskTypeOptions: '/taskTypeOptions',

    applicationOptions: '/applications',

    organizationOptions: '/organizations',

    brandSafetyLevels: '/brandSafetyLevels',

    verificationPartners: '/verificationPartners',

    whitelabelDomains: '/whitelabel_domains',
  }
);

export default masterDataApi;
